import React from "react";
import Layout from "../layout/Layout";
import { Card, Col, Flex, Row, Typography } from "antd";
import hasPermission from "../../utils/permissions";
const { Title, Text } = Typography;

const UploadList = ({ history }) => {
	return (
		<Layout title="Upload Files" description="Files">
			<Row gutter={16}>
				<Col span={8}>
					<Card
						variant="borderless"
						style={{ backgroundColor: "#0c377d", cursor: "pointer" }}
						onClick={() => history.push("/upload/materialusage/list")}
					>
						<Flex align="center" justify="center" vertical>
							<Title level={2} style={{ color: "white" }}>
								Material Usage By Mix
							</Title>
							<Text style={{ color: "white" }}>Upload List</Text>
						</Flex>
					</Card>
				</Col>
				{hasPermission("uploads:57files:view") && (
					<Col span={8}>
						<Card
							variant="borderless"
							style={{ backgroundColor: "#0c377d", cursor: "pointer" }}
							onClick={() => history.push("/upload/57files/list")}
						>
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									57 Files
								</Title>
								<Text style={{ color: "white" }}>57 File List</Text>
							</Flex>
						</Card>
					</Col>
				)}
			</Row>
		</Layout>
	);
};

export default UploadList;
